import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PortalApiService } from '../shared/services/api/portal-api.service';
import { finalize } from 'rxjs/operators';

const apiEndpoints = {
  directLink: 'practitioneranon/directlink'
}

@Injectable()
export class DirectLinkService {

  constructor(
    private portalApiService: PortalApiService
    ) { }
    getSetting(guid: string, email: string): Observable<any> {
      return this.portalApiService.get(apiEndpoints.directLink.concat(`/${guid}?x=${email}`))
        .pipe(finalize(() => null));
    }

    updateSetting(guid:string, email: string, opt: any):Observable<any> {
      return this.portalApiService.post(apiEndpoints.directLink.concat(`/${guid}?x=${email}&opt=${opt}`));
    }

}
